<template>
  <div>
    <template v-for="value in this.menuList">
      <el-submenu
      class="submenu"
        :index="value.Url"
        
        @click="toLink(value.Url, value.Target)"
        v-if="hasChild(value.ID) && value.IsDropDown == '1'"
        :key="value.ID + ''"
      >
        <template slot="title">
          <i :class="value.Icon"></i>
          {{ value.Name }}
        </template>
        <my-menu :pID="value.ID"></my-menu>
      </el-submenu>
      <el-menu-item
        :index="value.Url"
        v-else
        :key="value.ID + ''"
        @click="toLink(value.Url, value.Target)"
      >
        <i :class="value.Icon"></i>
        {{ value.Name }}
      </el-menu-item>
    </template>
  </div>
</template>
<script>
import { menuRouteMixin } from "../../mixins/menuRoute";
export default {
  name: "MyMenu",
  mixins: [menuRouteMixin],
  props: ["pID"],
  created() {
    this.menuData = this.$store.state.menuData;
    this.rootID = this.pID;
    this.getChild();
  },
  data() {
    return {
      rootID: "0",
      menuData: this.$store.state.menuData,
      menuList: [],
      skinType: this.$store.state.skinType,
    };
  },

  methods: {
    getChild() {
      let that = this;
      that.menuList = that.menuData.filter(function (m) {
        return m.ParentID == that.rootID;
      });
    },
    hasChild(id) {
      let that = this;
      let tempMenuList = that.menuData.filter(function (m) {
        return m.ParentID == id;
      });
      return tempMenuList.length > 0;
    },
  },
};
</script>
<style lang="less" scoped>

/deep/ .el-submenu__title{
  font-size:17px !important;
  margin-left:5px;
  
}
/deep/.el-submenu__icon-arrow {
    font-size: 14px !important;
    line-height:14px !important;
}
/deep/ .el-submenu .el-submenu__title {
        height: 40px  !important;
        line-height: 40px  !important;
}
</style>
